import useSWR from 'swr';
import { SwrReturnType } from '~/models/Api';
import { DealSurvey } from '~/models/Survey';

const paths = {
  index: '/deals/:deal_id/deal_surveys'
};

type TIndex = (id: number | null) => SwrReturnType<DealSurvey[]>;
type ReturnType = {
  index: TIndex;
};

export const useDealSurveys = (): ReturnType => {
  const index: TIndex = (dealId: number | null) => {
    const { data, mutate, error } = useSWR<DealSurvey[]>(
      dealId === null ? null : paths.index.replace(':deal_id', String(dealId))
    );
    return {
      data: data ?? null,
      mutate,
      isLoading: !data && !error,
      error
    };
  };
  return { index };
};
